/* Nur laden, wenn form vorhanden! */

/* General variables */
const memberForm = document.getElementById('registerMember')

if (memberForm) {
  const formId = memberForm.id
  // const formSubmit = form.querySelector('button[type="submit"]')

  /* Fieldset variables */
  const fieldsetWeitereAdressdaten = document.getElementById(`${formId}-fieldset-weitere-adressdaten`)
  const fieldsetWeitereKontaktdaten = document.getElementById(`${formId}-fieldset-weitere-kontaktdaten`)
  const fieldsetBankdaten = document.getElementById(`${formId}-fieldset-bankdaten`)

  /* Single item variables */
  const itemCheckboxWeitereAdressdaten = document.getElementById(`${formId}-checkbox-weitere-adressdaten`)
  const itemCheckboxWeitereKontaktdaten = document.getElementById(`${formId}-checkbox-weitere-kontaktdaten`)
  const itemRadioZahlungsweise = document.getElementById(`${formId}-asdebitauthorization`)
  const itemRadioZahlungsweise0 = document.getElementById(`${formId}-asdebitauthorization-0`)
  const itemRadioAdressePrivat = document.getElementById(`${formId}-ctrl_setpostaladdress-0`)
  const itemRadioAdressePraxis = document.getElementById(`${formId}-ctrl_setpostaladdress-1`)
  const itemHiddenAdressePrivatSuffix = document.getElementById(`${formId}-adpostaladdresses_0_suffix`)
  const itemHiddenAdressePraxisSuffix = document.getElementById(`${formId}-adpostaladdresses_1_suffix`)
  const itemConfirmAGB = document.getElementById(`${formId}-dataPrivacy`)
  const itemConfirmAGBSummary = document.getElementById(`summary-dataPrivacy`)
  const submitButton = memberForm.querySelector(`.btn-group.submit button[type="submit"]`)

  /* Generic functions */

  /**
   * Changes the state of the item, e.g. checks or unchecks a checkbox
   *
   * @param {element} item The item to be changed
   * @param {boolean} activate Activate or deactivate the item
   */
  const changeItemStatus = (item, activate = true) => {
    switch (item.type) {
      case 'checkbox':
        if (activate) {
          item.checked = true
        } else {
          item.checked = false
        }
        break
      default:
        break
    }
  }

  /**
   * Changes the visibility of the item by adding a class
   *
   * @param {element} item The item to be changed
   * @param {boolean} makeVisible Make it visible or invisible
   */
  const changeVisibility = (item, makeVisible = true) => {
    if (makeVisible) {
      item.classList.remove('is--hidden')
    } else {
      item.classList.add('is--hidden')
    }
  }

  /**
   * Makes items inside the fieldset mandatory or non-mandatory for tx_forms
   *
   * @param {element} fieldset The fieldset that contains the items
   * @param {array} exceptions IDs of items that should be ignored
   * @param {boolean} mandatory Make the items mandatory or non-mandatory
   */
  const changeFieldsetMandatory = (fieldset, exceptions = [], mandatory = true) => {
    const inputs = fieldset.querySelectorAll('input:not([type="hidden"]), select:not([type="hidden"])')

    inputs.forEach(input => {
      const label = fieldset.querySelector(`label[for="${input.id}"]`)

      if (!exceptions.includes(input.id)) {
        input.required = mandatory

        if (mandatory) {
          if (!label.querySelector('span.required')) {
            const requiredSpan = document.createElement('SPAN')
            requiredSpan.classList.add('required')
            requiredSpan.textContent = ' *'
            label.appendChild(requiredSpan)
          }
        } else {
          const requiredSpan = label.querySelector('span.required')
          if (requiredSpan) {
            requiredSpan.remove()
          }
        }
      }
    })
  }

  /**
   * Adds a css-class to parent of a defined element (both selected by query selector)
   *
   * @param {string} element Selector for the child item
   * @param {string} parent Selector for the parent item
   * @param {string} newClass Class that should be added to the parent element
   */
  const addClassToElementsParent = (element, parent, newClass) => {
    const elements = el.querySelectorAll(element)

    elements.forEach(element => {
      const parentElement = element.closest(parent)
      parentElement.classList.add(newClass)
    })
  }

  /* Listener Actions & Registrations. Contains the logic what happens when. Non generic. */

  const changeCheckboxWeitereAdressdaten = () => {
    if (itemCheckboxWeitereAdressdaten.checked) {
      changeVisibility(fieldsetWeitereAdressdaten)
      // changeFieldsetMandatory(fieldsetWeitereAdressdaten)
    } else {
      changeVisibility(fieldsetWeitereAdressdaten, false)
      const fieldsetsWeitereAdressdatenInputs = fieldsetWeitereAdressdaten.querySelectorAll('input:not([type="radio"])')
      fieldsetsWeitereAdressdatenInputs.forEach(input => {
        input.value = ''
      })

      itemRadioAdressePrivat.checked = true
      itemRadioAdressePraxis.checked = false

      itemHiddenAdressePrivatSuffix.value = 'Privat (Post)'
      itemHiddenAdressePraxisSuffix.value = 'Praxis'

      // changeFieldsetMandatory(fieldsetWeitereAdressdaten, [], false)
    }
  }

  const changeCheckboxWeitereKontaktdaten = () => {
    if (itemCheckboxWeitereKontaktdaten.checked) {
      changeVisibility(fieldsetWeitereKontaktdaten)
      // changeFieldsetMandatory(fieldsetWeitereKontaktdaten)
    } else {
      changeVisibility(fieldsetWeitereKontaktdaten, false)
      // changeFieldsetMandatory(fieldsetWeitereKontaktdaten, [], false)
    }
  }

  const changeRadioAdresstyp = (type) => {
    if (type === 'Privat') {
      itemHiddenAdressePrivatSuffix.value = 'Privat (Post)'
      itemHiddenAdressePraxisSuffix.value = 'Praxis'
    } else {
      itemHiddenAdressePrivatSuffix.value = 'Privat'
      itemHiddenAdressePraxisSuffix.value = 'Praxis (Post)'
    }
  }

  const changeRadioZahlungsweise = (show) => {
    if (show === '0') {
      changeVisibility(fieldsetBankdaten, false)
      changeFieldsetMandatory(fieldsetBankdaten, [], false)
    } else {
      changeVisibility(fieldsetBankdaten)
      changeFieldsetMandatory(fieldsetBankdaten)
    }
  }

  /* Add a link to the AGB checkbox text */
  const addLinksToAGBCheckbox = (e) => { // e?
    let string = e.nextElementSibling.innerHTML
    string = string.replace('###Datenschutz###', '<a href="/datenschutz" target="_blank">Datenschutz</a>').replace('###Beitragsordnung###', '<a href="/beitragsordnung" target="_blank">Beitragsordnung</a>').replace('###Satzung###', '<a href="/satzung" target="_blank">Satzung</a>')
    e.nextElementSibling.innerHTML = string
  }

  const handleSubmitButton = () => {
    const formNavigation = memberForm.querySelector(`.form-navigation .btn-group[role="group"]`)

    const submitForm = e => {
      const loaderContainer = document.createElement('div')
      loaderContainer.classList.add('loader')

      formNavigation.classList.add('is--submitted')
      memberForm.appendChild(loaderContainer)
    }
    memberForm.addEventListener('submit', submitForm)
  }

  /* Init */
  // addClassToElementsParent('.input.checkbox', '.form-group', 'is--fullwidth')
  if (itemCheckboxWeitereAdressdaten) {
    itemCheckboxWeitereAdressdaten.addEventListener('change', changeCheckboxWeitereAdressdaten)
    changeCheckboxWeitereAdressdaten()
  }
  if (itemCheckboxWeitereKontaktdaten) {
    itemCheckboxWeitereKontaktdaten.addEventListener('change', changeCheckboxWeitereKontaktdaten)
    changeCheckboxWeitereKontaktdaten()
  }
  if (itemRadioZahlungsweise) {
    itemRadioZahlungsweise.addEventListener('change', (e) => changeRadioZahlungsweise(e.target.value))
    changeRadioZahlungsweise(itemRadioZahlungsweise0.checked ? '0' : '1')
  }
  if (itemRadioAdressePrivat) {
    itemRadioAdressePrivat.addEventListener('change', (e) => changeRadioAdresstyp(e.target.value))
    itemRadioAdressePraxis.addEventListener('change', (e) => changeRadioAdresstyp(e.target.value))
    // changeRadioAdresstyp(itemRadioAdressePraxis.checked ? 'Praxis' : 'Privat')
  }
  if (itemConfirmAGB) {
    addLinksToAGBCheckbox(itemConfirmAGB) // omit param?
  }
  if (itemConfirmAGBSummary) {
    addLinksToAGBCheckbox(itemConfirmAGBSummary) // omit param?
  }
  if (submitButton) {
    handleSubmitButton()
  }
}
